// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopFood_wrapper__27w3j","dishTitle":"TopFood_dishTitle__3UvkZ","dishPrice":"TopFood_dishPrice__3YQqb","card":"TopFood_card__3w0IL","media":"TopFood_media__RzB5m"};